export default __webpack_public_path__ + "static/logo-black-29336324fe5a0b090990b3abbbb0dd3a.png";